export default "__VITE_ASSET__BvRzpODA__"